<div class="activity-stream-header-container">
  <div class="section">
    <p>{{ (items$ | async)?.length }} {{ 'activity-stream.events-listed' | translate }}</p>
  </div>
  @for (section of sections; track section) {
    <div
      class="section"
      [style.background-color]="section.backgroundColor">
      @if (section.icon) {
        <mat-icon>{{ section.icon }}</mat-icon>
      }
      <p class="bold">{{ section.name | translate }}</p>
    </div>
  }
</div>
